import { IoCheckmarkCircleOutline } from 'react-icons/io5';
import { BiCoinStack } from 'react-icons/bi';
import { IoLockClosedOutline } from 'react-icons/io5';
import { BiLike } from 'react-icons/bi';
import img1 from '../../../../assets/img/Services/IotEdgeSolution/aiml.jpg';

import { IoCloudUploadOutline } from 'react-icons/io5';
import { IoAnalytics } from 'react-icons/io5';
import { IoIosTimer } from "react-icons/io";
import { LuBrainCircuit } from "react-icons/lu";

export default function MainSection3() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
              AI/ML Analytics
            </h1>
            <p className="text-lg text-gray-600">
              Leverage AI/ML technologies to analyze real-time data streams.
              Detect anomalies, identify failure patterns, and predict
              maintenance needs with data-driven precision
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                < IoIosTimer className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Real-Time Anomaly Detection
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Identify irregularities instantly to mitigate risks.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <IoAnalytics className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Failure Pattern Recognition
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Spot trends and prevent breakdowns with predictive analytics.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <LuBrainCircuit className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Proactive Maintenance
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Use AI/ML insights to predict and schedule maintenance
                efficiently.
              </p>
            </div> 

            {/* Feature 4 */}
            {/* <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <BiLike className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">All in One</h3>
              </div>
              <p className="text-gray-600 text-sm">
                All-in-one solution ensures that you can easily manage your financial needs.
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
